export default "__VITE_ASSET__70dc6b11__"